import { array, InferOutput, literal, object } from 'valibot'
import { ArmorSchema } from '../../Armor.type'
import { AttackedThisTurnSchema } from '../../AttackedThisTurn'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { entityTypeDefaults, EntityTypeMeta } from '../../EntityTypeMeta'
import { FuelSchema } from '../../fuel.type'
import { HasMobilitySchema } from '../../has_mobility'
import { HasXYSchema } from '../../has_xy'
import { HPSchema } from '../../hp.type'
import { PlayerIdOrNullSchema } from '../../player/PlayerIdOrNull'
import { VisionSchema } from '../../vision.type'
import { WasBuiltThisTurnSchema } from '../../WasBuiltThisTurn'
import { ArmorTypeId } from '../Armor/ArmorTypeId.enum'
import { BaseEntitySchema } from '../BaseEntity'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'
import { MoveTypeId } from '../move_type_id.enum'
import createArtillaryCannonWeapon from '../Weapon/createArtillaryCannonWeapon'
import { WeaponSchema } from '../Weapon/Weapon.type'

const entDefaults = {
  etype_id: EntityTypeId.MediumArtillary,
  layer_id: EntityLayerId.Unit2,
  hp: 10,
  fuel: 50,
  vision: 1,
  mtype_id: MoveTypeId.Treads,
  mobility: 5,
  // range: 2-3,
  armor: 5,
} as const

function defaultWeapons() {
  return [createArtillaryCannonWeapon(10)]
}

export const MediumArtillaryEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.MediumArtillary),
  layer_id: literal(EntityLayerId.Unit2),
  id: EntityIdSchema,
  player_id: PlayerIdOrNullSchema,
  hp: HPSchema,
  fuel: FuelSchema,
  vision: VisionSchema,
  armor: ArmorSchema,
  ...HasXYSchema.entries,
  ...HasMobilitySchema.entries,
  builtThisTurn: WasBuiltThisTurnSchema,
  attackedThisTurn: AttackedThisTurnSchema,
  weapons: array(WeaponSchema),
})

export type MediumArtillaryEntity = InferOutput<typeof MediumArtillaryEntitySchema>

/**
 * Mobile artillery unit equipped with a medium-caliber howitzer for indirect fire support.
 */
export const MediumArtillaryEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.MediumArtillary,
  dname: 'Medium Artillary',
  layer_id: EntityLayerId.Unit2,
  group_id: EntityTypeGroupId.Unit,
  entDefaults,
  price: 60,
  defaultWeapons,
  armor_type: ArmorTypeId.LightVehicle,
}

export function createMediumArtillaryEntity(
  id: number,
  x: number,
  y: number,
  player_id: number | null
): MediumArtillaryEntity {
  return {
    ...entDefaults,
    heading: 0,
    weapons: defaultWeapons(),
    id,
    x,
    y,
    player_id,
  }
}
